var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolutionsEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 243,
    viewBox: "0 0 203 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1198_103993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.665 192.71C197.825 192.71 197.995 192.71 198.155 192.73H198.245L201.385 192.89V176.45C201.385 172.18 197.905 168.7 193.635 168.7H177.175L177.155 171.68C177.135 174.83 175.895 177.8 173.655 180.03C171.415 182.26 168.405 183.52 165.215 183.52C162.025 183.52 159.035 182.28 156.775 180.03C154.535 177.79 153.295 174.83 153.275 171.68L153.255 168.7H137.215C132.945 168.7 129.465 172.18 129.465 176.45V232.86C129.465 237.13 132.945 240.61 137.215 240.61V240.59H193.635C197.905 240.59 201.385 237.11 201.385 232.84V216.4L198.245 216.55H198.155C197.995 216.56 197.825 216.57 197.665 216.57C194.475 216.57 191.475 215.33 189.225 213.08C184.575 208.43 184.575 200.86 189.225 196.21C191.475 193.96 194.475 192.71 197.665 192.71Z",
    fill: "#3A3E47",
    stroke: "#4B5057",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.255 173.67C113.435 170.85 109.685 169.3 105.695 169.3C104.225 169.3 102.765 169.52 101.375 169.94V156.03C101.375 151.76 97.8948 148.28 93.6248 148.28H77.1848L77.3348 151.42V151.52C77.3448 151.68 77.3548 151.84 77.3548 152.01C77.3548 155.2 76.1148 158.2 73.8548 160.45C71.5948 162.7 68.6048 163.94 65.4148 163.94C62.2248 163.94 59.2248 162.7 56.9748 160.45C54.7248 158.2 53.4748 155.2 53.4748 152.01C53.4748 151.85 53.4748 151.68 53.4948 151.52V151.43L53.6548 148.28H37.2148C32.9448 148.28 29.4648 151.76 29.4648 156.03V212.44C29.4648 216.71 32.9448 220.19 37.2148 220.19H93.6248C97.8948 220.19 101.375 216.71 101.375 212.44V198.53C102.765 198.95 104.225 199.17 105.695 199.17C109.685 199.17 113.435 197.62 116.255 194.8C122.075 188.98 122.075 179.5 116.255 173.68V173.67Z",
    fill: "#3A3E47",
    stroke: "#4B5057",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.336 59.1399H125.926C121.656 59.1399 118.176 62.6199 118.176 66.8899V83.3299L121.326 83.1799H121.426C121.586 83.1699 121.746 83.1599 121.916 83.1599C125.106 83.1599 128.106 84.3999 130.356 86.6599C135.006 91.3099 135.006 98.8799 130.356 103.53C128.106 105.78 125.106 107.03 121.916 107.03C121.756 107.03 121.586 107.03 121.426 107.01H121.336L118.186 106.85V123.29C118.186 127.56 121.666 131.04 125.936 131.04H140.336C138.336 136.43 139.596 142.56 143.796 146.76C146.616 149.58 150.366 151.13 154.356 151.13H154.346C158.336 151.14 162.086 149.59 164.906 146.77C169.106 142.57 170.366 136.44 168.366 131.05H182.336C186.606 131.05 190.086 127.57 190.086 123.3V66.8899C190.086 62.6199 186.606 59.1399 182.336 59.1399Z",
    fill: "#3A3E47",
    stroke: "#4B5057",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.375 33.9001L132.845 28.8001L130.395 27.3301L128.815 29.7201L119.625 43.5301L113.455 52.8001L123.445 47.8901L141.165 39.1701L146.115 36.7301L141.375 33.9001Z",
    fill: "#3A3E47",
    stroke: "#4B5057",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2752 34.43L77.0852 20.62L75.5052 18.23L73.0552 19.7L64.5252 24.8L59.7852 27.63L64.7352 30.07L82.4552 38.79L92.4452 43.7L86.2752 34.43Z",
    fill: "#3A3E47",
    stroke: "#4B5057",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.945 7.50008L100.585 4.17008L95.375 2.33008L96.655 7.70008L101.225 26.9101L103.795 37.7401L107.015 27.0801L111.805 11.2001L112.635 8.46008L109.945 7.50008Z",
    fill: "#3A3E47",
    stroke: "#4B5057",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.635 75.7301L54.755 35.8501C53.295 34.3901 51.345 33.5801 49.275 33.5801C47.205 33.5801 45.255 34.3901 43.795 35.8501L3.895 75.7301C2.435 77.1901 1.625 79.1401 1.625 81.2101C1.625 83.2801 2.435 85.2301 3.895 86.6901L13.775 96.5701C8.555 98.9701 5.105 104.19 5.105 110.13C5.105 118.36 11.805 125.06 20.035 125.06C25.975 125.06 31.195 121.61 33.595 116.39L43.775 126.57C45.235 128.03 47.185 128.84 49.255 128.84H49.275C51.345 128.84 53.295 128.03 54.755 126.57L64.585 116.74C67.125 121.52 72.115 124.62 77.755 124.62C85.985 124.62 92.685 117.92 92.685 109.69C92.685 104.06 89.585 99.0601 84.805 96.5201L94.635 86.6901C97.655 83.6701 97.655 78.7501 94.635 75.7301Z",
    fill: "#3A3E47",
    stroke: "#4B5057",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1198_103993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202.76,
    height: 242.11,
    fill: "white",
    transform: "translate(0.125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionsEmpty);
export default __webpack_public_path__ + "static/media/SolutionsEmpty.aa825c5c6abd8e07b5e76a2581968e61.svg";
export { ForwardRef as ReactComponent };